import React, { Suspense } from "react";
import { Route } from "react-router";

export function generateRoutesFromConfig(config) {
  return config.map((route, index) => (
    <Route
      key={`${route.path}-${index}`}
      path={route.path}
      element={
        route.element && (
          <Suspense fallback={<></>}>
            {React.createElement(route.element)}
          </Suspense>
        )
      }
    >
      {route.children && generateRoutesFromConfig(route.children)}
    </Route>
  ));
}
